/**
 * App-wide Axios instance. Vite aliases `axios` → this module so every
 * `import axios from 'axios'` (and axios-hooks) shares one client that tests
 * can mock without stomping a process-wide singleton across workers.
 */
import Axios from 'axios-lib';
import type { AxiosInstance, AxiosStatic } from 'axios-lib';

const httpClient = Axios.create({
  baseURL: import.meta.env.VITE_FIXTURE_API || '/',
}) as AxiosInstance & Pick<
  AxiosStatic,
  | 'isCancel'
  | 'isAxiosError'
  | 'CancelToken'
  | 'AxiosError'
  | 'AxiosHeaders'
  | 'all'
  | 'spread'
  | 'create'
  | 'VERSION'
>;

// Call sites use axios.isCancel / isAxiosError / CancelToken on the default import.
httpClient.isCancel = Axios.isCancel.bind(Axios);
httpClient.isAxiosError = Axios.isAxiosError.bind(Axios);
httpClient.CancelToken = Axios.CancelToken;
httpClient.AxiosError = Axios.AxiosError;
httpClient.AxiosHeaders = Axios.AxiosHeaders;
httpClient.all = Axios.all.bind(Axios);
httpClient.spread = Axios.spread.bind(Axios);
httpClient.create = Axios.create.bind(Axios);
Object.defineProperty(httpClient, 'VERSION', {
  value: Axios.VERSION,
  writable: false,
  configurable: true,
});

export * from 'axios-lib';
export default httpClient;
